/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finish_Confirm_IntroInputs */



/**
* | output |
* | --- |
* | "This ends the event and finalizes the results:" |
*
* @param {Finish_Confirm_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_intro = /** @type {((inputs?: Finish_Confirm_IntroInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_IntroInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela met fin à l'événement et finalise les résultats :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto pone fin al evento y finaliza los resultados:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Isso encerra o evento e finaliza os resultados:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo conclude l'evento e finalizza i risultati:")
	return /** @type {LocalizedString} */ ("This ends the event and finalizes the results:")
});